import canConfiguratorChoices from '~/data/configuratorChoices/canConfiguratorChoices';
import { ProductViewConfigurator } from '~/types/configurator';

export default {
    controls: [
        {
            key: 'type',
            keyLabel: 'Can Type',
            choices: [
                {
                    label: 'Beaded',
                    value: 'beaded',
                },
                {
                    label: 'Straight',
                    value: 'straight',
                },
            ],
            hideOnProductPage: true,
        },
        {
            key: 'printStyle',
            keyLabel: 'Print Style',
            choices: [
                {
                    label: 'Printed',
                    value: 'printed',
                },
                {
                    label: 'Labeled',
                    value: 'labeled',
                },
            ],
            hideOnProductPage: true,
        },
        {
            key: 'lidStyle',
            keyLabel: 'Lid Style',
            choices: [
                {
                    label: 'Clear',
                    value: 'clear',
                },
                {
                    label: 'Black',
                    value: 'black',
                },
                {
                    label: 'Metal',
                    value: 'metal',
                },
            ],
            hideOnProductPage: true,
        },
        canConfiguratorChoices.size,
    ],
} as ProductViewConfigurator;
